import { Component, HostListener,ElementRef, OnInit } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
    selector: 'app-headerfr',
    templateUrl: './headerfr.component.html',
    styleUrls: ['./headerfr.component.scss'],
    animations: [
        trigger('widthGrow', [
            state('closed', style({
                height: 0,
            })),
            state('open', style({
                height: 100
            })),
            transition('* => *', animate(150))
        ]),
        trigger('widthGrow2', [
            state('closed', style({
                height: 0,
            })),
            state('open', style({
                height: 100,
            })),
            transition('* => *', animate(150))
        ]),
        trigger('widthGrow3', [
            state('closed', style({
                height: 0,
            })),
            state('open', style({
                height: 100,
            })),
            transition('* => *', animate(150))
        ])
    ],
    standalone: false
})
export class HeaderfrComponent implements OnInit {
  public myLinks: boolean = false;
  public navhaem: boolean = true;
  divsec2: boolean = false;
  divsec3: boolean = false;
  divsec: boolean = false;

  testvisible: boolean = true;
  testvisible2: boolean = true;
  testvisible3: boolean = true;

  trainingImg: boolean = false;
  supportImg: boolean = false;
  healthcareImg: boolean = false;
  scrollBottom: any;
  @HostListener('window:scroll', ['$event.target'])
  onscroll(e:any)  {
    this.scrollBottom = e.scrollingElement.scrollTop;
    this.checkHeightToAnimate();
  }


  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
  }
  state = "closed";
  state2 = "closed";
  state3 = "closed";
  checkHeightToAnimate() {
    try {
        if (this.checkScrollHeightBottom(this.scrollBottom,(this.elementRef.nativeElement.querySelector('#programpillars').offsetTop-100)))
          this.elementRef.nativeElement.querySelector('#programpillars').classList.add('pre-animate');
        
      } catch (e) {}
}
  checkScrollHeightBottom(x: any, y: any) {
    if (x >= (y))
        return true;
    else
        return false;
}

showState(): void {
  if(this.state == "closed"){
   this.state = "open";
  this.divsec = true;
  this.testvisible=false;
  this.trainingImg =true;
}
else{
  this.hidestate();
}
}

showState2(): void {
   if(this.state2 == "closed") { 
    this.state2 = "open";
    this.divsec2 = true;
    this.testvisible2=false;
    this.supportImg =true;
   }
   else{
    this.hidestate2();
   }
}

showState3(): void {
  if(this.state3 == "closed"){ 
    this.state3 = "open";
    this.divsec3 = true;
    this.testvisible3=false;
    this.healthcareImg=true;
  }
  else{
    this.hidestate3();
  }
}
  hidestate(): void {
    (this.state == "open") ? this.state = "closed" : this.state = "closed";
    this.divsec = false;
    this.testvisible = true;
    this.trainingImg = false;
  }

  hidestate2(): void {
    (this.state2 == "open") ? this.state2 = "closed" : this.state2 = "closed";
    this.divsec2 = false;
    this.testvisible2 = true;
    this.supportImg = false;
  }
  hidestate3(): void {
    (this.state3 == "open") ? this.state3 = "closed" : this.state3 = "closed";
    this.divsec3 = false;
    this.testvisible3 = true;
    this.healthcareImg = false;
  }

  scroll(id) {
    document.querySelector(id).scrollIntoView({ behavior: 'smooth' });
  }

  navmobile() {
    if (this.myLinks == true) {
      this.myLinks = false;
      this.elementRef.nativeElement.querySelector('.hero_video').classList.remove('hidevideo')
      this.elementRef.nativeElement.querySelector('.hero_video').classList.add('showvideo');
    }
    else {
      this.myLinks = true;
      this.elementRef.nativeElement.querySelector('.hero_video').classList.remove('showvideo')
      this.elementRef.nativeElement.querySelector('.hero_video').classList.add('hidevideo');
    }

    if (this.navhaem == true) {
      this.navhaem = false;
    }
    else {
      this.navhaem = true;
    }
  }
}

